// Invoice Fields
export const VENDOR_ID = "vendorId";
export const PAYMENT_TERM_ID = "paymentTermId";
export const PAYMENT_METHOD = "paymentMethodId";
export const BILLING_CATEGORY = "billingCategory";
export const ZONE_ID = "zoneId";
export const BLOCK_ID = "blockId";
export const PROPERTY_ID = "propertyId";
export const PROPERTY_OWNERSHIP_ID = "propertyOwnershipId";
export const GL_MASTER = "glMasterId";
export const BANK_ACC_GL = "bankAccountGlId";
export const BANK_CHARGES = "bankChargeAmount";
export const BANK_ACC_NAME = "bankAccountName";
export const ALT_GL_MASTER = "alternativeAccount";
export const TRANSACTION_TYPE = "transactionType";
export const LINE_ITEM_TYPE = "lineItemType";
export const BUDGET_YEAR = "budgetYear";
export const BUDGET_START_MONTH = "budgetMonthStart";
export const BUDGET_END_MONTH = "budgetMonthEnd";
export const BALANCE_AMOUNT = "balanceAmount";
export const POSTING_DATE = "postingDate";
export const POSTING_YEAR = "postingYear";
export const POSTING_PERIOD = "postingPeriod";
export const UNITS = "numberOfUnits";
export const RATE = "ratePerUnit";
export const AMOUNT = "amount";
export const CURRENCY = "invoiceCurrency";

export const INVOICE_DATE = "invoiceDate";
export const INVOICE_NO = "invoiceNumber";
export const INVOICE_REF = "invoiceRef";
export const DOC_NO = "postDocumentHeaderId";
export const DOC_TYPE = "documentType";
export const HEADER_TEXT = "headerText";
export const BASELINE_DATE = "baselineDate";
export const DUE_DATE = "dueDate";
export const PAY_BLOCK = "payBlock";
export const DRCR = "drCr";
export const INVOICE_AMT = "invoiceAmount";
export const APPROVED_AMT = "approvedAmount";

export const LI_INVOICE_DATE = "liInvoiceDate";
export const LI_INVOICE_NO = "liInvoiceNumber";
export const LI_INVOICE_REF = "liInvoiceRef";
export const LI_DOC_NO = "liPostDocumentHeaderId";
export const LI_DOC_TYPE = "liDocumentType";
export const LI_HEADER_TEXT = "liHeaderText";
export const LI_BASELINE_DATE = "liBaselineDate";
export const LI_DUE_DATE = "liDueDate";
export const LI_PAY_BLOCK = "liPayBlock";
export const LI_DRCR = "drCr";
export const LI_INVOICE_AMT = "liInvoiceAmount";
export const LI_APPROVED_AMT = "liApprovedAmount";

export const skippedFields = [BUDGET_END_MONTH, BUDGET_START_MONTH, BALANCE_AMOUNT, LINE_ITEM_TYPE];

export const isFieldSkipped = (fieldName: string) => {
  return skippedFields.includes(fieldName)
}

export const invoiceFields = [
  // {fieldName: GL_MASTER, fieldDataType: "LOOKUP", displayLabel: "GL Account"},
  {fieldName: INVOICE_DATE, fieldDataType: "DATE", displayLabel: "Invoice Date"},
  {fieldName: INVOICE_NO, fieldDataType: "STRING", displayLabel: "Invoice No"},
  {fieldName: INVOICE_REF, fieldDataType: "STRING", displayLabel: "Invoice Ref"},
  {fieldName: DOC_NO, fieldDataType: "STRING", displayLabel: "Doc No"},
  {fieldName: DOC_TYPE, fieldDataType: "STRING", displayLabel: "Doc Type"},
  {fieldName: HEADER_TEXT, fieldDataType: "STRING", displayLabel: "Header Text"},
  {fieldName: BASELINE_DATE, fieldDataType: "DATE", displayLabel: "Baseline Date"},
  {fieldName: DUE_DATE, fieldDataType: "DATE", displayLabel: "Due Date"},
  {fieldName: PAY_BLOCK, fieldDataType: "BOOLEAN", displayLabel: "Pay Block"},
  {fieldName: DRCR, fieldDataType: "LOOKUP", displayLabel: "Dr/Cr"},
  {fieldName: INVOICE_AMT, fieldDataType: "STRING", displayLabel: "Invoice Amt."},
  {fieldName: APPROVED_AMT, fieldDataType: "STRING", displayLabel: "Approved Amt."},
]